import makeStyles from '@mui/styles/makeStyles';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  root: {
    display: `${isMobile ? 'block' : 'flex'}`,
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: theme.spacing(3),
  },
}));

export default useStyles;
